<div  id="targetRed">
  <form [formGroup]="form" (ngSubmit)="onOrderSubmit()">
    <section class="pd-tb completeProfile">
      <div class="container">
          <div class="topHeader"> 
            <!-- <a href="javascript:void(0)" [routerLink]="'/subscription/'+prodId" class="bkbtn"> -->
            <a href="javascript:void(0)" (click)="goToBack(prodId)" class="bkbtn">
              <img src="../../../../assets/images/arrow_back.svg" class="ht"> Back</a>
          </div>
          <div class="personal-info">
                  <div class="row"> 
                      <div class="col-md-12paymentinfo"> 
                              <h6>Billing address</h6>
                              <div class=" d-flex justify-content-between">
                                <div class="form-group">
                                    <label>First Name <span class="orange">*</span></label>
                                    <input type="input" class="form-control"  placeholder="Enter" formControlName="firstName" minLength="3" maxlength="30"/>
                                    <div class="text-danger" *ngIf="form.controls['firstName'].hasError('required') && showError">
                                        *Please enter first name.
                                    </div> 
                                    <div class="text-danger" *ngIf="form.controls['firstName'].hasError('minlength') && showError">
                                        *Minimum length of 3 characters.
                                    </div> 
                                </div>
    
                                <div class="form-group">
                                    <label>Last Name <span class="orange">*</span></label>
                                    <input type="input" class="form-control" placeholder="Enter" formControlName="lastName" minLength="3" maxlength="30"/>
                                    <div class="text-danger" *ngIf="form.controls['lastName'].hasError('required') && showError">
                                        *Please enter last name.
                                    </div>  
                                    <div class="text-danger" *ngIf="form.controls['lastName'].hasError('minlength') && showError">
                                        *Minimum length of 3 characters.
                                    </div>        
                                </div>
                              </div>
                              
                              <div class=" d-flex justify-content-between">
                                <div class="form-group">
                                  <label>Phone number <span class="orange">*</span></label>
                                  <div class="countryCode">
                                    <span><input type="text" class="form-control" formControlName="countryCode" readonly placeholder="(+1)"/></span>
                                    <input type="text" class="form-control" placeholder="Enter " formControlName="phoneNumber" appPhoneMask id="phone-number" (keypress)="preventNumbers($event)"  maxlength="10">
                                  </div>
                                  <div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
                                      *Please enter phone number.
                                  </div>
                                  <div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('minlength') && showError">
                                      *Minimum length of 10 digit.
                                  </div> 
                                </div> 
                                <div class="form-group">
                                  <label>Company name <span class="orange">*</span></label>
                                  <input type="text" class="form-control"  placeholder="Enter" formControlName="companyName" maxlength="100"/>
                                  <div class="text-danger" *ngIf="form.controls['companyName'].hasError('required') && showError">
                                      *Please enter company name.
                                  </div>   
                                  <div class="text-danger" *ngIf="form.controls['companyName'].hasError('minlength') && showError">
                                      *Minimum length of 3 characters.
                                  </div> 
                                </div> 
                              </div>
                              <div class="form-group">
                                <label>Address <span class="orange">*</span></label>
                                <input type="text" class="form-control"  placeholder=" Cr 92 No. 34E-112, Medellín" formControlName="address" maxlength="500">
                                <div class="text-danger" *ngIf="form.controls['address'].hasError('required') && showError">
                                    *Please enter address.
                                </div>
                              </div> 
                              
                              <div class=" d-flex justify-content-between">
                              <div class="form-group">
                                <label>State <span class="orange">*</span></label>
                                <select class="form-control" formControlName="state">
                                  <option selected="selected" disabled  hidden> Please select</option>
                                  <option *ngFor="let states of allStates;let i=index;" [value]="states.name"> {{states.name}}</option>
                                </select> 
                                <div class="text-danger" *ngIf="form.controls['state'].hasError('required') && showError">
                                      *Please select the state.
                                </div>
                              </div>
                                <div class="form-group">
                                    <label>City <span class="orange">*</span></label>
                                    <input type="text" class="form-control" placeholder="Enter " formControlName="city">
                                    <div class="text-danger" *ngIf="form.controls['city'].hasError('required') && showError">
                                        *Please enter city.
                                    </div>
                                </div>
                                </div>
                                
                              <div class=" d-flex justify-content-between">
                                <div class="form-group">
                                    <label>Zip Code<span class="orange">*</span></label>
                                    <input type="input" class="form-control" placeholder="Enter" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6">
                                    <div class="text-danger" *ngIf="form.controls['zipCode'].hasError('required') && showError">
                                        *Please enter zip code.
                                    </div>       
                                </div>
                                
                              <div class="form-group">
                                <label> Country <span class="orange">*</span></label>
                                <select class="form-control" formControlName="countryName">
                                  <option disabled selected> Please select</option>
                                  <option value="USA"> USA</option>
                                </select>
                                <div class="text-danger" *ngIf="form.controls['countryName'].hasError('required') && showError">
                                    *Please select the country.
                                </div>
                              </div>
                              </div>  
                              <div class="form-group">
                                <input type="submit" class="planbtn fill" value="Save Address"/>
                              </div> 
                      </div>
                </div>
           </div>
        </div>
      </section> 
     
    </form> 
</div>